// extracted by mini-css-extract-plugin
module.exports = {"liveIcon":"LiveIcon_liveIcon__2uh5o"};